import * as Sentry from "@sentry/react";
// Inherit sentry's error boundary, 'GenericErrorBoundary' is already referenced everywhere in the code
// TODO: fine-tune this component, this has the potential to put all Sentry code in ONE place,
// once that is done, we get the following benefits without losing Sentry's monitoring capacities
// no more merge headaches caused by sentry instrumentation code change, 
// no more referencing Sentry in a thousand places, because the rest of the code can just reference this
// if we ever want to swap out Sentry for something else, it can be done in one place too
// the documentation for sentry's error boundary is here, looks promising
// https://docs.sentry.io/platforms/javascript/guides/react/features/error-boundary/.
// 
export class GenericErrorBoundary extends Sentry.ErrorBoundary {

    // The following WAS the original GenericErrorBoundary's implementation
    // commented out to preserve all Sentry's factory behavior

    // constructor(props) {
    //   super(props);
    //   this.state = {
    //     hasError: false,
    //     error: { message: '', stack: '' },
    //     errorInfo: { componentStack: '' }
    //   };
    // }
  
    // static getDerivedStateFromError(error) {
    //   // Update state so the next render will show the fallback UI.
    //   return { hasError: true };
    // }
  
    // componentDidCatch(error, errorInfo) {
    //     this.setState({ "hasError":true, error, errorInfo });
    // }
  
    // render() {
    //   if (this.state.hasError) {
    //     // render any custom fallback UI
    //     return <h1>Something went wrong.</h1>;
    //   }
  
    //   return this.props.children; 
    // }
  }

  